const VimeoPopup = {
    popup: null,
    videoPreview: null,
    playBtn: null,
    closeBtn: null,
    vimeoFrame: null,
    currentVideoId: null,
    videoUrl: '',
    videoId: null,

    init() {
        document.querySelectorAll('.video-trigger').forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                this.videoId = trigger.dataset.vimeoId;
                const videoUrl = trigger.dataset.vimeoUrl;
                const bgImage = trigger.dataset.bg;

                this.popup = document.getElementById('videoPopup_'+this.videoId);
                this.videoPreview = document.getElementById('videoPreview_'+this.videoId);
                this.playBtn = document.getElementById('playBtn_'+this.videoId);
                this.closeBtn = document.getElementById('closeBtn_'+this.videoId);
                this.vimeoFrame = document.getElementById('vimeoFrame_'+this.videoId);
                this.playBtn.addEventListener('click', () => this.playVideo());
                this.closeBtn.addEventListener('click', () => this.closePopup());

                if(bgImage) {
                    this.videoPreview.style.background = `url('${bgImage}') center center / cover no-repeat`;
                }

                this.popup.addEventListener('click', (e) => {
                    if (e.target === this.popup) this.closePopup();
                });

                document.addEventListener('keydown', (e) => {
                    if (e.key === 'Escape' && this.popup.classList.contains('active')) {
                        this.closePopup();
                    }
                });
                console.log(videoUrl, 'videoUrl')
                this.openPopup(videoUrl);
            });
        });


    },

    openPopup(videoUrl) {
        this.videoUrl = videoUrl;
        this.popup.classList.add('active');
        this.videoPreview.classList.remove('hidden');
        this.vimeoFrame.style.display = 'none';
        document.body.style.overflow = 'hidden';
    },
    checkVimeo() {
        return fetch(`https://vimeo.com/api/oembed.json?url=${this.videoUrl}`)
            .then(response => {
                if (!response.ok) throw new Error("Vidéo introuvable");
                return response.json();
            });
    },
    playVideo() {

        if (!this.videoUrl) return;

        this.checkVimeo(this.videoUrl)
            .then(data => {
                this.vimeoFrame.src = `${this.videoUrl}?autoplay=1&title=0&byline=0&portrait=0&color=1ab7ea`;
                this.vimeoFrame.style.display = 'block';
                this.videoPreview.classList.add('hidden');
            })
            .catch(err => {
                console.error(err);
                alert("Cette vidéo n’existe pas ou n’est pas disponible.");
            });

    },

    closePopup() {
        this.popup.classList.remove('active');
        setTimeout(() => {
            this.vimeoFrame.src = '';
            this.videoPreview.classList.remove('hidden');
            this.vimeoFrame.style.display = 'none';
        }, 300);
        document.body.style.overflow = '';
    }
}

// Init
export default VimeoPopup;
